var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_info",
    "data-name": "icon / info",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18.09,
    viewBox: "0 0 18 18.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M41.6,3.7A8.639,8.639,0,0,1,47.99,1a8.3,8.3,0,0,1,6.3,2.7,8.556,8.556,0,0,1,2.61,6.39,8.908,8.908,0,0,1-2.61,6.39,8.556,8.556,0,0,1-6.39,2.61,8.908,8.908,0,0,1-6.39-2.61,8.556,8.556,0,0,1-2.61-6.39A9.212,9.212,0,0,1,41.6,3.7Zm1.26,11.43a6.957,6.957,0,0,0,5.04,2.16,6.811,6.811,0,0,0,5.04-2.16,6.957,6.957,0,0,0,2.16-5.04,6.671,6.671,0,0,0-2.16-5.04A6.4,6.4,0,0,0,47.99,2.8a6.811,6.811,0,0,0-5.04,2.16A6.957,6.957,0,0,0,40.79,10,6.6,6.6,0,0,0,42.86,15.13ZM47.09,5.5h1.8v5.4h-1.8Zm0,7.2h1.8v1.8h-1.8Z",
    transform: "translate(56.9 19.09) rotate(180)",
    fill: "#ed6073"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoRed);
export default __webpack_public_path__ + "static/media/icon_info_red.52919812a28b477dd681a57990c6b9dd.svg";
export { ForwardRef as ReactComponent };